import React, { useState, useEffect } from 'react';
import { useMutation, useQuery } from '@apollo/client';
// eslint-disable-next-line import/no-unresolved
import { CREATE_USER_REGISTRATION } from 'Apollo/Mutations';
// eslint-disable-next-line import/no-unresolved
import { GET_INSTITUTION_LIST } from 'Apollo/Queries';
import { useHistory } from 'react-router-dom';
import { isValidDomain } from '../../../../utils';
import '../styles/signup.scss';
import '../styles/selfsignup.scss';
import SelfSignup from '../components/SelfSignup';

const SelfSignupContainer = () => {
    const [email, setEmail] = useState('');
    const [institution, setInstitution] = useState('');
    const [disableBtn, setDisableBtn] = useState(true);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [emailError, setEmailError] = useState('');
    const [institutionList, setInstitutionList] = useState([]);

    const history = useHistory();

    /* apollo mutation to register new user in IAM service */
    const [createUserRegistration, { loading: registerUserLoading }] = useMutation(CREATE_USER_REGISTRATION);
    const { data: institutionData } = useQuery(GET_INSTITUTION_LIST);

    const validateEmail = () => {
        if (!/\S+@\S+\.\S+/.test(email)) {
            setEmailError('Invalid email');
            return false;
        }

        const restrictedDomain = isValidDomain(email);
        if (restrictedDomain) {
            setEmailError(`The domain ${restrictedDomain} is restricted. Please use a different email.`);
            return false;
        }

        setEmailError('');
        return true;
    };

    const onSave = async () => {
        setShowErrorAlert(false);

        if (validateEmail()) {
            try {
                const { data } = await createUserRegistration({
                    variables: {
                        input: {
                            email,
                            institution,
                            invitationStatus: 'PENDING',
                        },
                    },
                });

                if (data.createUserRegistratationIntake) {
                    setShowSuccessAlert(true);
                    setShowErrorAlert(false);
                    setErrorMsg('');
                    setEmail('');
                    setInstitution('');
                } else {
                    setErrorMsg('Registration failed.');
                    setShowErrorAlert(true);
                }
            } catch (err) {
                setErrorMsg('Something went wrong. Please try again.');
                setShowErrorAlert(true);
            }
        }
    };

    useEffect(() => {
        if (institutionData?.getInstitutionList?.length) {
            const parsed = institutionData.getInstitutionList.map(entry => ({
                label: entry,
                value: entry,
            }));
            setInstitutionList(parsed);
        }
    }, [institutionData]);

    useEffect(() => {
        const allFieldsFilled = email.trim() && institution.trim() && validateEmail();

        setDisableBtn(!allFieldsFilled);
    }, [email, institution]);

    useEffect(() => {
        if (showSuccessAlert) {
            const timer = setTimeout(() => {
                setShowSuccessAlert(false);
                history.push('/login');
            }, 6000);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [showSuccessAlert, history]);

    return (
        <SelfSignup
            email={email}
            setEmail={setEmail}
            institution={institution}
            setInstitution={setInstitution}
            disableBtn={disableBtn}
            setDisableBtn={setDisableBtn}
            showErrorAlert={showErrorAlert}
            setShowErrorAlert={setShowErrorAlert}
            showSuccessAlert={showSuccessAlert}
            errorMsg={errorMsg}
            emailError={emailError}
            setErrorMsg={setErrorMsg}
            onSave={onSave}
            institutionsList={institutionList}
            registerUserLoading={registerUserLoading}
            validateEmail={validateEmail}
        />
    );
};

export default SelfSignupContainer;
